<template lang='pug'>
  HomeAdmin(v-if="$store.state.dataUsers.role=='admin'" :title='title')
  HomeUsers(v-else-if="$store.state.dataUsers.role=='general'" :title='title')
</template>

<script>
import HomeAdmin from "../components/HomeAdmin.vue";
import HomeUsers from "../components/HomeUsers.vue";
export default {
  name: "Home",
  components: {
    HomeAdmin,
    HomeUsers
  },
  data: () => ({
    title: "Homepage"
  }),
};
</script>

<style>
.v-main__wrap{
  background: #F3F3F4;
}

.v-application .blue {
  background-color: #01C8F1!important;
  border-color: #01C8F1!important;
}
</style>
